// Build-time retirement switch. The previous build remains the rollback artifact.
const LEGACY_VIEWER = process.env.REACT_APP_LEGACY_VIEWER === 'true';
export const V4_ENTRY_PATH = '/student_experience/client-entry';
export const SAVED_WORK_PATH = '/saved-work';
export default LEGACY_VIEWER;
